import PropTypes from "prop-types";
import React from "react";

import EditDestinationForm from "v2/components/responsive/EditDestinationForm";
import ModalLink from "v2/components/responsive/ModalLink";

const EditDestinationLink = (props, context) => {
  const {params: {date, id, routeId}} = context;
  return (
    <ModalLink
      className="erg-inline-block"
      form={EditDestinationForm}
      icon="pencil"
      label="Edit"
      linkClassName="erg-add-link"
      url={`/${date}/${routeId}/${id}/edit`}
      {...props} />
  );
};

EditDestinationLink.contextTypes = {
  params: PropTypes.shape({
    date: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    routeId: PropTypes.string.isRequired,
  }),
};

export default EditDestinationLink;



/** WEBPACK FOOTER **
 ** ./src/app/v2/components/responsive/EditDestinationLink.js
 **/